import Dropdown from '../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../Services/Language/useLanguageHook';
import { MarginQuarterOptions, MarginQuarterValue, MarginRequest } from '../../RiskDefinitions';

interface IEndingQuarterDropdownProps {
    marginRequest: MarginRequest;
    handleSetEndingQuarter: (marginQuarterValue: MarginQuarterValue) => void;
    quarterOptions: MarginQuarterOptions[];
    disabled?: boolean;
}

const EndingQuarterDropdown = (props: IEndingQuarterDropdownProps) => {
    const [translations] = useLanguage();

    return (
        <div>
            <Dropdown
                testId="EndingQuarterDropdown"
                value={props.marginRequest.endingQuarter}
                options={props.quarterOptions}
                handleOptionChange={(value) => props.handleSetEndingQuarter(value)}
                label={translations.risk.margin.fields.endingQuarter}
                disabled={props.disabled}
                track={{ eventCategory: 'MarginCalculator', eventAction: 'EndingQuarterChanged' }}
            />
        </div>
    );
};

export default EndingQuarterDropdown;
